import { render } from "./KeywordsInputKeywordTappable.vue?vue&type=template&id=684ff477"
import script from "./KeywordsInputKeywordTappable.vue?vue&type=script&lang=js"
export * from "./KeywordsInputKeywordTappable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__